import { Alert, Button, Modal } from 'react-bootstrap';
import { IRecipient } from '@nkr/models/recipient';

interface IProps {
    show: boolean,
    compatibilityResultsRecipient: IRecipient,
    placeHolderRecipient: IRecipient,
    onConfirm: (recipientId: number) => void,
    onCancel: () => void
}

const ConfirmWaitlistReplace = (props: IProps) => {
    if (props.compatibilityResultsRecipient == null || props.placeHolderRecipient == null) {
        return null;
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Replacement
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' style={{ marginBottom: 0, paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>
                    <div style={{ marginBottom: 5 }}>Recipient <strong>{props.placeHolderRecipient.alias}</strong> will be removed from the list.</div>
                    <div style={{ marginBottom: 5 }}>Recipient <strong>{props.compatibilityResultsRecipient.alias}</strong> will be swapped to position <strong>{props.placeHolderRecipient.position}</strong>.</div>
                    <div style={{ fontSize: 16 }}><strong>Are you sure you would like to proceed?</strong></div>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={() => props.onConfirm(props.compatibilityResultsRecipient.id)}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmWaitlistReplace;